<template>
  <div id="admin">
    <el-row class="header">
      <el-col :span="22" class="logo" align="left" style="font-size: 20px; font-weight: bold;">
        公路路面沉降监测系统
      </el-col>
      <el-col :span="2" class="user-settings-col">
        <el-dropdown class="user-settings" @command="handleSystemDropdown">
          <span class="el-dropdown-link">
            {{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item>修改密码</el-dropdown-item> -->
            <!-- <el-dropdown-item divided command="logout">登出</el-dropdown-item> -->
            <el-dropdown-item command="logout">登出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
    <el-row class="main">
      <el-col :span="2" :sm="{span:6}" :lg="{span:2}" :xs="{span:5}" :md="{ span:6}">
        <el-menu default-active="2" class="menu" @select="handleMenu" background-color="#222d32"
          text-color="#fff" active-text-color="#ffd04b">
          <el-menu-item-group title="首页">
            <el-menu-item index="0-1">首页</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group title="系统管理">
            <el-menu-item index="1-1">用户管理</el-menu-item>
            <el-menu-item index="1-2">路段管理</el-menu-item>
            <el-menu-item index="1-3">切面管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group title="数据管理">
            <el-menu-item index="2-1">设备状态</el-menu-item>
            <el-menu-item index="2-2">数据查询</el-menu-item>
          </el-menu-item-group>
        </el-menu>
      </el-col>
      <el-col :span="22" :sm="{span:18}" :lg="{span:22}" :xs="{ span: 19}" :md="{span:18}">
        <el-row v-if="menuIndex === '0-1'">
          <admin-home />
        </el-row>
        <el-row v-if="menuIndex === '1-1'">
          <user-manage />
        </el-row>
        <el-row v-if="menuIndex === '1-2'">
          <project-manage />
        </el-row>
        <el-row v-if="menuIndex === '1-3'">
          <segment-manage />
        </el-row>
        <el-row v-if="menuIndex === '2-1'">
          <device-status />
        </el-row>
        <el-row v-if="menuIndex === '2-2'">
          <data-query />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import DataQuery from '@/components/admin/DataQuery'
import DeviceStatus from './components/admin/DeviceStatus.vue'
import ProjectManage from '@/components/admin/ProjectManage'
import UserManage from '@/components/admin/UserManage'
import SegmentManage from '@/components/admin/SegmentManage'
import AdminHome from './components/admin/AdminHome.vue'
export default {
  name: 'admin',
  components: {
    DataQuery,ProjectManage,UserManage,SegmentManage,AdminHome, DeviceStatus
  },
  data() {
    return {
      menuIndex: '0-1',
      username: ''
    }
  },
  mounted() {
    this.username = localStorage.getItem('username')
  },
  methods: {
    handleSystemDropdown(command) {
      localStorage.removeItem('userType');
      localStorage.removeItem('username');
      localStorage.removeItem('token');
      this.$router.push('/login');
    },
    handleMenu(index,indexPath) {
      this.menuIndex = index;
    }
  }
}
</script>

<style lang="less" scoped>
#admin {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.logo {
  padding-left: 30px;
  height: 60px;
  color: white;
  line-height: 60px;
  background-color: #3c8dbc;
}

.header {
  box-shadow: 2px 2px 2px rgb(128, 128, 128);
}

.user-settings {
  height: 60px;
  line-height: 60px;
}

.menu {
  height: calc(100vh - 60px);
  text-align: left;
}
</style>
<style>
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.main {
  height: 100%;
  background-color: #ecf0f5;
}
</style>